/**
 * Statsig 事件总表。最多两层：模块.事件。
 *
 *   import { STATSIG, PAGE } from '../statsig/events'
 *   STATSIG.AUTH.LOGIN   → AUTH_BORROWER_LOGIN
 *   STATSIG.LOAN.INSERT  → LOAN_INSERT
 *   STATSIG.LOANS.LOAN_OPEN → LOANS_LOAN_OPEN
 *   STATSIG.PAYMENT.PAY  → PAYMENT_CREDIT_PULL_PAY
 *   STATSIG.COMMON.VIEW
 *
 * 页面访问统一 STATSIG.COMMON.VIEW → PAGE_VIEW，value 用 PAGE。
 */
import { AuthEvent, getAuthSource } from './auth'
import { CommonEvent, PAGE } from './common'
import { LoanEvent, getLoanUpdateValue, loanTabValue } from './loan'
import { LoansEvent } from './loans'
import { PaymentEvent } from './payment'

export * from './auth'
export * from './common'
export * from './loan'
export * from './loans'
export * from './payment'
export * from './preapp'

export const STATSIG = {
    /** 借款人登录 / 注册（控制台名带 BORROWER，区别于 LOS 的 AUTH_LOGIN） */
    AUTH: AuthEvent,
    /** 单笔贷款工作台（1003 / TAB 等） */
    LOAN: LoanEvent,
    /** My Loans 列表 */
    LOANS: LoansEvent,
    /** 付款（征信付费等） */
    PAYMENT: PaymentEvent,
    /** 全站公共事件 */
    COMMON: CommonEvent,
}

export type StatsigEventName =
    | AuthEvent
    | LoanEvent
    | LoansEvent
    | PaymentEvent
    | CommonEvent

export { PAGE, getLoanUpdateValue, getAuthSource, loanTabValue }
